export * from './types';
export var ICON_SCRIPT_URL = 'https://at.alicdn.com/t/c/font_3267196_jnb7oe820r.js';
export var ICON_RTL_SCRIPT_URL = 'https://at.alicdn.com/t/a/font_4598247_piqs5ld1o5.js';
